<template>
    <nav class="menu">
        <ul class="tabs">
            <li :class="['tab', 'tab--logo', { active: isRTBActive() }]">
                <a :href="defaultRtbHome" class="tab-link">
                    <img src="/images/2digital-horis.png" alt="2Digital" class="logo-icon" />
                </a>
            </li>

            <!-- RTB выпадающее меню -->
            <li :class="['tab', 'tab--dropdown', { active: isRTBActive(), open: isRTBOpen }]" @mouseenter="openRTB"
                @mouseleave="closeRTB">
                <a :href="defaultRtbHome" class="tab-link">
                    <span class="label">RTB</span>
                    <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </a>
                <ul v-if="isRTBOpen" class="dropdown-menu dropdown-menu--rtb">
                    <li v-if="!userData?.is_user_standard" class="dropdown-card">
                        <div class="dropdown-card__title">Кампании RTB</div>
                        <a href="/rtb/campaigns" class="dropdown-item">
                            Кампании
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/campaigns/create')">+</button>
                        </a>
                    </li>
                    <li v-if="!userData?.is_user_pro" class="dropdown-card">
                        <div class="dropdown-card__title">Пакеты экранов</div>
                        <a href="/rtb/package-campaigns" class="dropdown-item">
                            Кампании
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/package-campaigns/create')">+</button>
                        </a>
                        <a href="/rtb/package-stats" class="dropdown-item">
                            Статистика
                        </a>
                    </li>
                    <li class="dropdown-card">
                        <div class="dropdown-card__title">POI-слои</div>
                        <a v-if="!userData?.is_user_pro" href="/rtb/poi-campaigns" class="dropdown-item">
                            Кампании
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/poi-campaigns/create')">+</button>
                        </a>
                        <a href="/rtb/poi-layers" class="dropdown-item">
                            Слои
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/poi-layers/create')">+</button>
                        </a>
                    </li>
                    <li class="dropdown-item-standalone">
                        <a href="/rtb/creatives" class="dropdown-item">
                            Креативы
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/creatives/create')">+</button>
                        </a>
                        <a href="/rtb/sms-requests" class="dropdown-item">
                            SMS-рассылки
                            <button type="button" class="add"
                                v-if="canWrite"
                                @click.stop.prevent="go('/rtb/sms-requests/create')">+</button>
                        </a>
                    </li>
                </ul>
            </li>

            <!-- Guaranteed выпадающее меню (временно отключено) -->
            <li :class="['tab', 'tab--dropdown', { 'tab--disabled': guaranteedDisabled, active: isGuaranteedActive() && !guaranteedDisabled, open: isGuaranteedOpen && !guaranteedDisabled }]"
                @mouseenter="openGuaranteed" @mouseleave="closeGuaranteed">
                <a :href="guaranteedDisabled ? '#' : '/guaranteed/campaigns'" class="tab-link"
                    :aria-disabled="guaranteedDisabled" @click="onGuaranteedClick">
                    <span class="label">Guaranteed</span>
                    <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </a>
                <ul v-if="isGuaranteedOpen && !guaranteedDisabled" class="dropdown-menu">
                    <li>
                        <a href="/guaranteed/campaigns" class="dropdown-item">
                            Кампании
                            <button type="button" class="add"
                                @click.stop.prevent="go('/guaranteed/campaigns/create')">+</button>
                        </a>
                    </li>
                    <li>
                        <a href="/guaranteed/creatives" class="dropdown-item">
                            Креативы
                            <button type="button" class="add"
                                @click.stop.prevent="go('/guaranteed/creatives/create')">+</button>
                        </a>
                    </li>
                    <li>
                        <a href="/guaranteed/stats" class="dropdown-item">
                            Статистика
                        </a>
                    </li>
                </ul>
            </li>

            <li class="tab profile-tab" :class="{ 'profile-tab--open': isProfileMenuOpen }"
                @click.stop="toggleProfileMenu" ref="profileTab">
                <div class="profile-icon-wrapper">
                    <img src="/images/profile.png" alt="Profile" class="profile-icon" />
                    <span v-if="hasModerationItems" class="moderation-badge"></span>
                </div>
                <ul v-if="isProfileMenuOpen" class="profile-dropdown">
                    <li>
                        <a
                            href="/profile"
                            :class="['profile-dropdown-item', 'profile-dropdown-item--username', `profile-dropdown-item--username--${userRoleCode}`]"
                            @click="closeProfileMenu"
                        >
                            <img src="/images/profile.png" alt="Profile" class="profile-dropdown-avatar" />
                            <span>{{ userData?.email || userData?.name || userData?.login || 'Пользователь' }}</span>
                        </a>
                    </li>
                    <li v-if="canAccessAdministration">
                        <a href="/administration" class="profile-dropdown-item" @click="closeProfileMenu">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 17l10 5 10-5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M2 12l10 5 10-5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span>Администрирование</span>
                        </a>
                    </li>
                    <li v-if="userData?.is_admin">
                        <a href="/moderation" class="profile-dropdown-item" @click="closeProfileMenu">
                            <div class="profile-dropdown-icon-wrapper">
                                <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <polyline points="10 9 9 9 8 9" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span v-if="hasModerationItems" class="moderation-badge moderation-badge--small"></span>
                            </div>
                            <span>Модерация</span>
                            <span class="profile-dropdown-admin-badge" aria-label="Только для администратора">admin</span>
                        </a>
                    </li>
                    <li v-if="userData?.is_admin">
                        <a href="/rtb/requests" class="profile-dropdown-item" @click="closeProfileMenu">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 6h13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                <path d="M8 12h13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                <path d="M8 18h13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                <path d="M3 6h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                <path d="M3 12h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                <path d="M3 18h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <span>Запросы RTB</span>
                            <span class="profile-dropdown-admin-badge" aria-label="Только для администратора">admin</span>
                        </a>
                    </li>
                    <li>
                        <a href="/help" class="profile-dropdown-item" @click="closeProfileMenu">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>Помощь</span>
                        </a>
                    </li>
                    <li v-if="userData?.is_admin">
                        <a href="/help/rtb" class="profile-dropdown-item" @click="closeProfileMenu">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 12h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 3v18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Функционирование RTB</span>
                            <span class="profile-dropdown-admin-badge" aria-label="Только для администратора">admin</span>
                        </a>
                    </li>
                    <li v-if="userData?.is_admin || userData?.is_agency">
                        <a href="/help/agency" class="profile-dropdown-item" @click="closeProfileMenu">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <line x1="8" y1="7" x2="16" y2="7" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" />
                                <line x1="8" y1="11" x2="16" y2="11" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" />
                                <line x1="8" y1="15" x2="12" y2="15" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" />
                            </svg>
                            <span>Работа с платформой для агентств</span>
                        </a>
                    </li>
                    <li>
                        <button type="button" class="profile-dropdown-item profile-dropdown-item--logout"
                            @click="logout">
                            <svg class="profile-dropdown-icon" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" />
                            </svg>
                            <span>Выйти</span>
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'MenuTabs',
    props: {
        userData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            guaranteedDisabled: true,
            guaranteedOpen: false,
            rtbOpen: false,
            profileMenuOpen: false,
            moderationCounts: {
                campaigns: 0,
                advertisements: 0,
                creatives: 0,
                total: 0,
            },
        };
    },
    computed: {
        isAdmin() {
            return this.userData?.is_admin || false;
        },
        userRoleCode() {
            // Определяем роль пользователя
            if (this.userData?.is_admin) {
                return 'admin';
            }
            if (this.userData?.is_agency) {
                return 'agency';
            }
            if (this.userData?.is_user_pro) {
                return 'user_pro';
            }
            if (this.userData?.is_user_standard) {
                return 'user_standard';
            }
            // Если роль указана напрямую
            if (this.userData?.role) {
                return this.userData.role;
            }
            return 'default';
        },
        canWrite() {
            return this.userData?.can_write !== false;
        },
        canAccessAdministration() {
            return this.userData?.is_admin || this.userData?.is_agency;
        },
        isGuaranteedOpen() {
            return this.guaranteedOpen;
        },
        isRTBOpen() {
            return this.rtbOpen;
        },
        isProfileMenuOpen() {
            return this.profileMenuOpen;
        },
        hasModerationItems() {
            return this.userData?.is_admin && this.moderationCounts.total > 0;
        },
        defaultRtbHome() {
            if (this.userData?.is_user_standard) {
                return '/rtb/package-campaigns';
            }
            return '/rtb/campaigns';
        },
    },
    mounted() {
        // Закрываем меню при клике вне элемента
        document.addEventListener('click', this.handleClickOutside);

        // Загружаем счётчики модерации для админа
        if (this.userData?.is_admin) {
            this.loadModerationCounts();
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        go(route) {
            window.location.href = route;
        },
        isActive(route) {
            return window.location.pathname === route;
        },
        isGuaranteedActive() {
            const path = window.location.pathname;
            return path.startsWith('/guaranteed') || path === '/stats';
        },
        isRTBActive() {
            const path = window.location.pathname;
            return path.startsWith('/rtb');
        },
        openGuaranteed() {
            if (this.guaranteedDisabled) return;
            this.guaranteedOpen = true;
        },
        closeGuaranteed() {
            this.guaranteedOpen = false;
        },
        onGuaranteedClick(event) {
            if (this.guaranteedDisabled) {
                event.preventDefault();
            }
        },
        openRTB() {
            this.rtbOpen = true;
        },
        closeRTB() {
            this.rtbOpen = false;
        },
        toggleProfileMenu() {
            this.profileMenuOpen = !this.profileMenuOpen;
        },
        closeProfileMenu() {
            this.profileMenuOpen = false;
        },
        handleClickOutside(event) {
            if (this.$refs.profileTab && !this.$refs.profileTab.contains(event.target)) {
                this.closeProfileMenu();
            }
        },
        async logout() {
            this.closeProfileMenu();
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/logout';
            const token =
                document.querySelector('meta[name="csrf-token"]').getAttribute('content') || '';
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = '_token';
            input.value = token;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
        },
        async loadModerationCounts() {
            try {
                const response = await fetch('/api/moderation/counts', {
                    credentials: 'same-origin',
                    headers: {
                        'Accept': 'application/json',
                    },
                });
                if (response.ok) {
                    this.moderationCounts = await response.json();
                }
            } catch (e) {
                // Игнорируем ошибки - счётчики не критичны
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.menu {
    display: flex;
    width: 100%;
    height: 60px;
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 100;

    .tabs {
        display: flex;
        width: 100%;
        position: relative;

        .tab {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            gap: 6px;
            cursor: pointer;
            font-weight: 500;
            font-size: 14px;
            color: #555;
            box-shadow: 0 0px 2px rgba(0, 0, 0, 0.15);
            transition: all 0.2s ease;
            position: relative;
            flex: 1;

            .tab-link {
                width: 100%;
                display: flex;
                color: inherit;
                justify-content: center;
                align-items: center;
                gap: 10px;
            }

            .label {
                flex: none;
            }

            .dropdown-arrow {
                width: 16px;
                height: 16px;
                color: currentColor;
                transition: transform 0.3s ease;
                flex-shrink: 0;
            }

            &.tab--dropdown {
                &.open .dropdown-arrow {
                    transform: rotate(180deg);
                }
            }

            &.tab--disabled {
                color: #9ca3af;
                cursor: not-allowed;
                opacity: 0.6;
                pointer-events: none;

                .tab-link {
                    cursor: not-allowed;
                    color: inherit;
                }

                .label {
                    color: inherit;
                }

                .dropdown-arrow {
                    opacity: 0.5;
                }

                &:hover {
                    color: #9ca3af;
                    background: transparent;
                }
            }

            .add {
                flex: none;
                font-size: 20px;
                font-weight: bold;
                color: #007bff;
                padding: 0 15px;
                border-radius: 15%;
                transition: background 0.2s;
                text-decoration: none;
                display: inline-block;
                background: transparent;
                border: none;
                cursor: pointer;
                font-family: inherit;

                &:hover {
                    background: #e9f2ff;
                }
            }

            &:hover {
                color: #000;
                background: #f9f9f9;
            }

            &.active {
                color: #000;
                border-bottom: 3px solid #007bff;
                background: #fafafa;
            }

            &.tab--logo {
                width: auto;
                flex: 0 0 auto;
                padding: 0.5rem 1rem;

                .logo-icon {
                    height: 40px;
                    width: auto;
                    object-fit: contain;
                    transition: opacity 0.2s ease;
                }

                &:hover {
                    .logo-icon {
                        opacity: 0.8;
                    }
                }

                &.active {
                    border-bottom: none;
                }
            }

            &.profile-tab {
                width: 60px;
                flex: 0 0 auto;
                margin-left: auto;
                padding: 0;
                background: #fff;
                position: relative;
                cursor: pointer;
                transition: background 0.2s ease;

                .profile-icon-wrapper {
                    position: relative;
                    display: inline-flex;
                }

                .profile-icon {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                    padding: 0.5rem;
                    transition: opacity 0.2s ease;
                }

                .moderation-badge {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    width: 10px;
                    height: 10px;
                    background: #ef4444;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
                }

                &:hover {
                    background: #f9f9f9;

                    .profile-icon {
                        opacity: 0.8;
                    }
                }

                &.profile-tab--open {
                    background: #f0f0f0;

                    .profile-icon {
                        opacity: 0.9;
                    }
                }

                .profile-dropdown {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    background: #fff;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    list-style: none;
                    margin: 4px 0 0 0;
                    width: max-content;
                    min-width: 250px;
                    max-width: min(100vw - 24px, 480px);
                    z-index: 1000;

                    .profile-dropdown-item {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        width: 100%;
                        padding: 10px 16px;
                        color: #333;
                        text-decoration: none;
                        background: transparent;
                        border: none;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 500;
                        text-align: left;
                        white-space: nowrap;
                        transition: background 0.2s ease, color 0.2s ease;

                        &:not(:last-child) {
                            border-bottom: 1px solid #e5e7eb;
                        }

                        &--username {
                            cursor: pointer;
                            color: #666;
                            font-weight: 600;
                            background: #f9f9f9;

                            .profile-dropdown-avatar {
                                width: 18px;
                                height: 18px;
                                object-fit: cover;
                                flex-shrink: 0;
                            }

                            span {
                                color: #666;
                            }

                            &:hover {
                                filter: brightness(0.98);
                            }

                            // Стили для разных ролей
                            &--user_pro {
                                background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
                                border: 1px solid rgba(5, 95, 70, 0.1);
                                box-shadow: 0 1px 2px rgba(5, 95, 70, 0.05);

                                span {
                                    color: #065f46;
                                }

                                &:hover {
                                    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
                                }
                            }

                            &--user_standard {
                                background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
                                border: 1px solid rgba(146, 64, 14, 0.1);
                                box-shadow: 0 1px 2px rgba(146, 64, 14, 0.05);

                                span {
                                    color: #92400e;
                                }

                                &:hover {
                                    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
                                }
                            }

                            &--admin {
                                background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
                                border: 1px solid rgba(153, 27, 27, 0.1);
                                box-shadow: 0 1px 2px rgba(153, 27, 27, 0.05);

                                span {
                                    color: #991b1b;
                                }

                                &:hover {
                                    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
                                }
                            }

                            &--agency {
                                background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                                border: 1px solid rgba(30, 64, 175, 0.1);
                                box-shadow: 0 1px 2px rgba(30, 64, 175, 0.05);

                                span {
                                    color: #1e40af;
                                }

                                &:hover {
                                    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                                }
                            }

                            &--default {
                                background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
                                border: 1px solid rgba(55, 65, 81, 0.1);
                                box-shadow: 0 1px 2px rgba(55, 65, 81, 0.05);

                                span {
                                    color: #374151;
                                }

                                &:hover {
                                    background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
                                }
                            }
                        }

                        .profile-dropdown-icon-wrapper {
                            position: relative;
                            display: inline-flex;
                            flex-shrink: 0;

                            .moderation-badge--small {
                                position: absolute;
                                top: -2px;
                                right: -2px;
                                width: 8px;
                                height: 8px;
                                background: #ef4444;
                                border-radius: 50%;
                                border: 1px solid #fff;
                            }
                        }

                        .profile-dropdown-icon {
                            width: 18px;
                            height: 18px;
                            color: #333;
                            flex-shrink: 0;
                        }

                        .profile-dropdown-admin-badge {
                            margin-left: auto;
                            flex-shrink: 0;
                            padding: 2px 8px;
                            border-radius: 999px;
                            background: rgba(220, 38, 38, 0.12);
                            border: 1px solid rgba(185, 28, 28, 0.25);
                            color: #b91c1c;
                            font-size: 10px;
                            font-weight: 600;
                            line-height: 1.4;
                            letter-spacing: 0.02em;
                        }

                        span {
                            color: #333;
                        }

                        &:hover {
                            background: #f5f5f5;
                            color: #000;

                            span {
                                color: #000;
                            }

                            .profile-dropdown-admin-badge {
                                color: #b91c1c;
                            }

                            .profile-dropdown-icon {
                                color: #000;
                            }
                        }

                        // Красный цвет только для кнопки "Выйти"
                        &--logout {
                            color: #ef4444;

                            .profile-dropdown-icon {
                                color: #ef4444;
                            }

                            span {
                                color: #ef4444;
                            }

                            &:hover {
                                background: #fff5f5;
                                color: #dc2626;

                                span {
                                    color: #dc2626;
                                }

                                .profile-dropdown-icon {
                                    color: #dc2626;
                                }
                            }
                        }
                    }
                }
            }

            .dropdown-menu {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: #fff;
                border: 1px solid #e0e0e0;
                border-top: none;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                list-style: none;
                margin: 0;
                padding: 0;
                z-index: 1000;

                &--rtb {
                    padding: 8px;
                    min-width: 240px;
                    width: max-content;
                    right: auto;
                }

                .dropdown-card {
                    background: #f8f9fb;
                    border: 1px solid #e8eaed;
                    border-radius: 8px;
                    padding: 4px 0;
                    margin-bottom: 6px;
                    list-style: none;
                    overflow: hidden;

                    &:last-of-type {
                        margin-bottom: 0;
                    }

                    &__title {
                        font-size: 11px;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.04em;
                        color: #6b7280;
                        padding: 6px 12px 4px;
                    }

                    .dropdown-item {
                        padding: 0.6rem 12px;

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }

                .dropdown-item-standalone {
                    margin-top: 4px;
                    padding-top: 4px;
                    border-top: 1px solid #e8eaed;
                    list-style: none;

                    .dropdown-item {
                        border-radius: 8px;
                    }
                }

                .dropdown-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.75rem 1rem;
                    color: #555;
                    text-decoration: none;
                    transition: background 0.2s;
                    gap: 10px;

                    &:hover {
                        background: #f9f9f9;
                        color: #000;
                    }

                    .add {
                        font-size: 18px;
                        padding: 0 10px;
                        background: transparent;
                        border: none;
                        cursor: pointer;
                        font-family: inherit;
                        color: #007bff;
                        font-weight: bold;
                        border-radius: 15%;
                        transition: background 0.2s;

                        &:hover {
                            background: #e9f2ff;
                        }
                    }
                }
            }
        }
    }
}
</style>
